import { useRouter } from "next/router"

export const useRouterPatientId = () => {
    const router = useRouter()
    return router.pathname.startsWith(`/patient/[patientId]`) ? parseInt(router.query.patientId as string) : null
}
